import Icon from '../components/Icon.vue'

Icon.register({
  wrench: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M507.7 109.1C505.5 100.1 494.2 97 487.6 103.6L413.3 177.9 345.4 166.6 334.1 98.8 408.4 24.4C415 17.8 411.9 6.5 402.8 4.2 355.4-7.5 303.2 5.1 266.2 42.2 226.5 81.8 215.6 139.3 232.1 189.4L18.7 402.8C-6.3 427.8-6.3 468.3 18.7 493.3 43.7 518.3 84.3 518.3 109.2 493.3L322.4 280C372.6 296.8 429.9 285.7 469.8 245.8 506.9 208.8 519.5 156.5 507.7 109.1zM64 472C50.8 472 40 461.3 40 448 40 434.7 50.8 424 64 424S88 434.7 88 448C88 461.3 77.3 472 64 472z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wrench.js
// module id = jyUL
// module chunks = 144